import React from "react";
import TeamPageSectoin from "../../Sections/TeamPageSection/Content";
const TeamPage = () => {
  return <TeamPageSectoin />;
};

export default TeamPage;
